import React from 'react';
import type { CustomerStatementAgeing } from '@/services/financialReports.service';
import AgeingBar from '@/components/finance/report-document/AgeingBar';

export const AGEING_BUCKETS: Array<{ key: keyof CustomerStatementAgeing; label: string; color: string }> = [
  { key: 'not_due', label: 'Not yet due', color: '#2E7D5B' },
  { key: 'd1_30', label: '1 - 30 days', color: '#E0A526' },
  { key: 'd31_60', label: '31 - 60 days', color: '#E07B26' },
  { key: 'd61_90', label: '61 - 90 days', color: '#D9542C' },
  { key: 'd91_120', label: '91 - 120 days', color: '#B83A2E' },
  { key: 'over_120', label: 'Over 120 days', color: '#7F1D1D' },
];

interface Props {
  ageing: CustomerStatementAgeing;
  format: (n: number) => string;
}

const StatementAgeingBar: React.FC<Props> = ({ ageing, format }) => (
  <AgeingBar
    format={format}
    buckets={AGEING_BUCKETS.map((b) => ({ key: b.key, label: b.label, color: b.color, amount: ageing[b.key] ?? 0, overdue: b.key !== 'not_due' }))}
    extras={[{ label: 'Unapplied credits', amount: ageing.unapplied ?? 0 }]}
  />
);

export default StatementAgeingBar;
